import { render, staticRenderFns } from "./review-add-form.vue?vue&type=template&id=079773e2&scoped=true&"
import script from "./review-add-form.vue?vue&type=script&lang=js&"
export * from "./review-add-form.vue?vue&type=script&lang=js&"
import style0 from "./review-add-form.vue?vue&type=style&index=0&id=079773e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079773e2",
  null
  
)

export default component.exports